import { module } from "angular";
import { ConfirmVerificationComponent } from "./ConfirmVerificationComponent";

module("mmAuth").component("irConfirmUserVerification", new ConfirmVerificationComponent());
